module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_yakisoba.60035b7d.png";